// VConsole 配置开关
// 设置为 true 启用 VConsole，false 禁用
export const VCONSOLE_ENABLED = false; 

// 其他 VConsole 配置选项
export const VCONSOLE_CONFIG = {
  theme: 'dark', // 主题：'light' 或 'dark'
  defaultPlugins: ['system', 'network', 'element', 'storage'], // 默认插件
  maxLogNumber: 1000, // 最大日志数量
};

